import React, { useState, useMemo } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { PrimaryButton, SecondaryButton, ButtonText } from "@loanbossinc/component-library";
import { getEnvConfig } from "helpers/environment-config";
import styled from "styled-components";

const IMG_HEIGHT_WIDTH = 136;
const DV_APP_ID = "3fa9c4d0-c4c1-4428-ac86-66129387388e";

const StyledCard = styled.div`
  display: flex;
  width: 528px;
  height: ${IMG_HEIGHT_WIDTH}px;
  font-family: Work Sans;
`;

const IconContainer = styled.div`
  width: ${IMG_HEIGHT_WIDTH}px;
`;

const AppCard = ({ app, onActivateApp, onDeactivateApp, isSystemAdmin, history }) => {
  const flags = useFlags();

  const {
    logoImageUri = "",
    isActive = false,
    isPremiumApp = false,
    name = "",
    description = "",
    baseUrlConfigKey = "",
    route = ""
  } = useMemo(() => {
    if (app.id === DV_APP_ID) {
      const dvApp = Object.assign({}, app);
      if (isSystemAdmin || flags.bar586EnableNewDebtValuationPage) {
        Object.assign(dvApp, { baseUrlConfigKey: "newFrontendUrl", route: "/debt-valuation" });
      }
      return dvApp;
    }

    return app;
  }, [flags, app, isSystemAdmin]);

  const [btnOpenDisabled, setBtnOpenDisabled] = useState(false);

  const handleOpen = async () => {
    setBtnOpenDisabled(true);
    if (baseUrlConfigKey) {
      const baseUrl = await getEnvConfig(baseUrlConfigKey);
      if (baseUrl) {
        window.location.assign(baseUrl + route);
      }
    } else {
      history.push(route);
    }
  };

  return (
    <StyledCard>
      <IconContainer>
        <img height={IMG_HEIGHT_WIDTH} width={IMG_HEIGHT_WIDTH} src={logoImageUri} />
      </IconContainer>
      <div>
        <div style={{ fontWeight: "500", fontSize: "20px", marginBottom: "6px", paddingTop: "8px" }}>{name}</div>
        <div style={{ fontWeight: "400", fontSize: "13px", marginBottom: "10px", lineHeight: "16px" }}>{description}</div>
        <div>
          {isActive && <PrimaryButton id={`${name.replace(/\s/g, "-")}-Open`} size="sm-fluid" label="Open" onClick={handleOpen} disabled={btnOpenDisabled} />}
          {!isActive && isPremiumApp && <SecondaryButton size="sm-fluid" label="Contact Sales" href="mailto:sales@loanboss.com" />}
          {!isActive && !isPremiumApp && <SecondaryButton size="sm-fluid" label="Get" onClick={() => onActivateApp()} />}
          {!isActive && isSystemAdmin && <ButtonText size="sm-fluid" label="Activate" onClick={() => onActivateApp()} />}
          {isActive && isSystemAdmin && <ButtonText size="sm-fluid" label="Deactivate" onClick={() => onDeactivateApp()} />}
        </div>
      </div>
    </StyledCard>
  );
};

export default AppCard;
